import React from 'react';

const PolicySection = ({ number, title, children }) => {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-slate-900 mb-3">
        {number}. {title}
      </h2>
      <div className="text-slate-600 leading-relaxed space-y-3">
        {children}
      </div>
    </section>
  );
};

export default PolicySection;
